import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Home from './pages/Home';
import Services from './pages/Services';
import Projects from './pages/Projects';
import About from './pages/About';
import Contact from './pages/Contact';
import Resources from './pages/Resources';
import CouncilPage from './pages/CouncilPage';
import Generator from './pages/Generator';
import AdminCalculatorRates from './pages/AdminCalculatorRates';
import AdminResidentialCalculator from './pages/AdminResidentialCalculator';
import Login from './pages/Login';
import LoginStripe from './pages/LoginStripe';
import LoginCloudflare from './pages/LoginCloudflare';
import Bespoke from './pages/Bespoke';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Dashboard from './pages/Dashboard';
import MyPlans from './pages/MyPlans';
import WasteRoomBuilder from './pages/WasteRoomBuilder';
import WasteRoomPlanner from './pages/WasteRoomPlanner';
import SEEGenerator from './pages/SEEGenerator';
import VehicleAccessBuilder from './pages/VehicleAccessBuilder';
import VehicleAccessPlanner from './pages/VehicleAccessPlanner';
import ProjectWizard from './pages/ProjectWizard';
import PaymentSuccess from './pages/PaymentSuccess';
import AdminEnquiries from './pages/AdminEnquiries';
import AdminDashboard from './pages/AdminDashboard';
import AdminInvoices from './pages/AdminInvoices';
import AdminHome from './pages/AdminHome';
import AdminNSWCouncils from './pages/AdminNSWCouncils';
import AdminVICCouncils from './pages/AdminVICCouncils';
import Guidelines from './pages/Guidelines';
import WmpNsw from './pages/WmpNsw';
import WmpVic from './pages/WmpVic';
import WmpGuide from './pages/WmpGuide';

function App() {
  return (
    <HelmetProvider>
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* Public consultant pages */}
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/council/:slug" element={<CouncilPage />} />
          <Route path="/generator" element={<Generator />} />

          {/* Auth pages */}
          <Route path="/login" element={<LoginStripe />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />

          {/* Legacy / SEO pages */}
          <Route path="/bespoke" element={<Bespoke />} />
          <Route path="/waste-management-plan-nsw" element={<WmpNsw />} />
          <Route path="/waste-management-plan-vic" element={<WmpVic />} />
          <Route path="/what-is-a-waste-management-plan" element={<WmpGuide />} />

          {/* Protected: Dashboard & Tools */}
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/my-plans" element={<ProtectedRoute><MyPlans /></ProtectedRoute>} />
          <Route path="/waste-room-builder" element={<ProtectedRoute><WasteRoomBuilder /></ProtectedRoute>} />
          <Route path="/waste-room/:roomId" element={<ProtectedRoute><WasteRoomPlanner /></ProtectedRoute>} />
          <Route path="/see-generator" element={<ProtectedRoute><SEEGenerator /></ProtectedRoute>} />
          <Route path="/guidelines" element={<ProtectedRoute><Guidelines /></ProtectedRoute>} />
          <Route path="/vehicle-access" element={<ProtectedRoute><VehicleAccessBuilder /></ProtectedRoute>} />
          <Route path="/vehicle-access/:projectId" element={<ProtectedRoute><VehicleAccessPlanner /></ProtectedRoute>} />
          <Route path="/project/:projectId" element={<ProtectedRoute><ProjectWizard /></ProtectedRoute>} />
          <Route path="/project/:projectId/payment-success" element={<ProtectedRoute><PaymentSuccess /></ProtectedRoute>} />

          {/* Protected: Admin */}
          <Route path="/admin/enquiries" element={<ProtectedRoute><AdminEnquiries /></ProtectedRoute>} />
          <Route path="/admin/invoices" element={<ProtectedRoute><AdminInvoices /></ProtectedRoute>} />
          <Route path="/admin/nsw-councils" element={<ProtectedRoute><AdminNSWCouncils /></ProtectedRoute>} />
          <Route path="/admin/vic-councils" element={<ProtectedRoute><AdminVICCouncils /></ProtectedRoute>} />
          <Route path="/admin/users" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
          <Route path="/admin/dashboard" element={<ProtectedRoute><AdminHome /></ProtectedRoute>} />
          <Route path="/admin" element={<ProtectedRoute><AdminHome /></ProtectedRoute>} />
          <Route path="/admin/calculator-rates" element={<ProtectedRoute><AdminCalculatorRates /></ProtectedRoute>} />
          <Route path="/admin/residential-calculator" element={<ProtectedRoute><AdminResidentialCalculator /></ProtectedRoute>} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
